var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GetAllWebhooksAction } from 'app/webhooks/webhooks.actions';
import { getWebhookFilteredListSelector } from '../webhooks.reducer';
import { DataSource } from '@angular/cdk/collections';
import { Store } from '@ngrx/store';
var WebhookListData = /** @class */ (function (_super) {
    __extends(WebhookListData, _super);
    function WebhookListData(store) {
        var _this = _super.call(this) || this;
        _this.store = store;
        return _this;
    }
    WebhookListData.prototype.init = function () {
        this.store.dispatch(new GetAllWebhooksAction());
    };
    WebhookListData.prototype.connect = function () {
        return this.store.select(getWebhookFilteredListSelector);
    };
    WebhookListData.prototype.disconnect = function (collectionViewer) { };
    return WebhookListData;
}(DataSource));
export { WebhookListData };
